import packageJson from '../../package.json';
import { IPackageConfig } from '../models/app/IPackageConfig';
import { IPackageConfigEnvironments } from '../models/app/IPackageConfigEnvironments.js';
import { TExternalScript } from '../models/commonTypes';

export class Manifest {
	get version(): string {
		return packageJson.version;
	}
	get packageName(): string | undefined {
		return packageJson.name;
	}
	get packageConfig(): IPackageConfig {
		return (packageJson as any)['config'] || {};
	}
	get alias(): string | undefined {
		return this.packageConfig.alias;
	}
	get description(): string | undefined {
		return this.packageConfig.description;
	}
	get testEnvironments(): IPackageConfigEnvironments {
		return this.packageConfig.testEnvironments;
	}
	get ksysAppTemplateId(): string {
		return `${ this.packageName }`;
	}
	get storeKey(): string {
		return `${ this.ksysAppTemplateId }-v${ this.version }-store`;
	}
	get externalScripts(): TExternalScript[] {
		const scripts: TExternalScript[] = [];
		if (process.env.NODE_ENV !== 'development') {
			scripts.push(
				'vendor-mobx.4.9.4-react.16.8.6-react-dom.16.8.6-styled-components.4.2.0.min.js',
			);
			const { peerDependencies } = packageJson as any;
			const templatePackageKey = '@kurtosys/ksys-app-template';
			const templateVersion = peerDependencies[templatePackageKey];
			if (templateVersion) {
				scripts.push(`ksys-app-template-v${ templateVersion }.min.js`);
			}
		}

		// Polyfill URL API
		if (typeof window.URL !== 'function') {
			scripts.push('https://unpkg.com/url-polyfill@1.1.5/url-polyfill.js');
		}

		return scripts;
	}

	getBaseUrl(suffix: string = 'services/') {
		let response: string = `/${ suffix }`;
		const scriptFilename = `/main-${ this.packageName }.js`;
		const scripts = document.scripts;
		for (let i = 0; i < scripts.length; i++) {
			const script: HTMLScriptElement = scripts[i] as HTMLScriptElement;
			const url = script.hasAttribute('src') ? script.src : null;
			if (url && url.endsWith(scriptFilename)) {
				response = `${ url.replace(scriptFilename, '') }/${ suffix }`;
				break;
			}
		}
		return response;
	}
}